import React from 'react';
import { Table, Tag } from 'antd';
import { useQuery } from 'react-query';
import api from '../utils/api';

const Salary = () => {
    const { data: salaryData, isLoading } = useQuery('salary', async () => {
        const response = await api.get('/salary');
        return response.data.data;
    });

    const columns = [
        { title: 'Staff', key: 'staff', render: (_, r) => r.staff ? `${r.staff.firstName} ${r.staff.lastName}` : '-' },
        { title: 'Month', dataIndex: 'month', key: 'month' },
        { title: 'Year', dataIndex: 'year', key: 'year' },
        { title: 'Basic Salary', dataIndex: 'basicSalary', key: 'basicSalary', render: (amount) => `$${amount}` },
        { title: 'Total Amount', dataIndex: 'totalAmount', key: 'totalAmount', render: (amount) => `$${amount}` },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                const color = { pending: 'orange', paid: 'green', cancelled: 'red' }[status];
                return <Tag color={color}>{status.toUpperCase()}</Tag>;
            },
        },
    ];

    return (
        <div>
            <h1 style={{ marginBottom: 16 }}>Salary</h1>
            <Table columns={columns} dataSource={salaryData} rowKey="_id" loading={isLoading} />
        </div>
    );
};

export default Salary;
